var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChromeIconicLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 3.75C7.94329 3.75 4.25 7.44329 4.25 12C4.25 16.5567 7.94329 20.25 12.5 20.25C17.0567 20.25 20.75 16.5567 20.75 12C20.75 7.44329 17.0567 3.75 12.5 3.75ZM2.75 12C2.75 6.61487 7.11487 2.25 12.5 2.25C17.8851 2.25 22.25 6.61487 22.25 12C22.25 17.3851 17.8851 21.75 12.5 21.75C7.11487 21.75 2.75 17.3851 2.75 12Z",
    fill: "#841474"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5004 9.14844C10.926 9.14844 9.65039 10.4247 9.65039 11.9984C9.65039 13.573 10.9258 14.8484 12.5004 14.8484C14.0749 14.8484 15.3504 13.573 15.3504 11.9984C15.3504 10.4247 14.0748 9.14844 12.5004 9.14844ZM8.15039 11.9984C8.15039 9.59657 10.0973 7.64844 12.5004 7.64844C14.9035 7.64844 16.8504 9.59657 16.8504 11.9984C16.8504 14.4014 14.9034 16.3484 12.5004 16.3484C10.0974 16.3484 8.15039 14.4014 8.15039 11.9984Z",
    fill: "#841474"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9906 13.1512C16.3494 13.3582 16.4724 13.8169 16.2654 14.1757L12.1429 21.3212C11.9359 21.68 11.4773 21.803 11.1185 21.596C10.7597 21.389 10.6367 20.9304 10.8437 20.5716L14.9661 13.4261C15.1731 13.0673 15.6318 12.9443 15.9906 13.1512Z",
    fill: "#841474"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.88059 6.00708C5.23918 5.79976 5.69795 5.92239 5.90528 6.28098L10.0365 13.4265C10.2438 13.7851 10.1212 14.2438 9.76262 14.4512C9.40403 14.6585 8.94526 14.5359 8.73794 14.1773L4.60669 7.03177C4.39937 6.67317 4.522 6.21441 4.88059 6.00708Z",
    fill: "#841474"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.75 8.39844C11.75 7.98422 12.0858 7.64844 12.5 7.64844H20.7529C21.1672 7.64844 21.5029 7.98422 21.5029 8.39844C21.5029 8.81265 21.1672 9.14844 20.7529 9.14844H12.5C12.0858 9.14844 11.75 8.81265 11.75 8.39844Z",
    fill: "#841474"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChromeIconicLogo);
export default __webpack_public_path__ + "static/media/chrome-iconic-logo.6b2ff82b.svg";
export { ForwardRef as ReactComponent };